import { Component, OnInit } from '@angular/core';
import '@angular/localize/init';
import { Subject } from 'rxjs';
import { AppConfigService } from './services/app-config.service';
import { AuthService } from './services/auth.service';
import { AbstractComponent } from './shared/components/abstract-component';
import { IAppConfig } from './shared/interfaces/app-config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent extends AbstractComponent implements OnInit {
  title = 'SEDMS-KendoUI';
  userLoaded: Subject<boolean> = new Subject<boolean>();
  user: any;
  authResult: any;
  public isDialogVisible: boolean = false;
  showDetails = false;
  location = window.location.href;
  referrer = document.referrer;
  userAgent = navigator.userAgent;
  screenResolution = `${screen.width}x${screen.height}`;
  config: IAppConfig;

  constructor(
    private authService: AuthService,
    private appConfigService: AppConfigService,
  ) {
    super();
    this.config = this.appConfigService.getConfig();
  }

  ngOnInit() {
    this.authService.completeAuthentication();

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.config.googleTag}`;
    document.body.appendChild(script);
    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any[]): void {
      (window as any).dataLayer.push(args);
    }
    gtag('js', new Date());
    gtag('config', this.config.googleTag);
  }

  public openDialog(): void {
    this.isDialogVisible = true;
  }

  public closeDialog(): void {
    this.isDialogVisible = false;
    this.showDetails = false;
  }

  toggleDetails(event: Event) {
    event.preventDefault();
    this.showDetails = !this.showDetails;
  }

  afterOnDestroy(): void {
    // afterOnDestroy
  }
}
